import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

const ToggleBox = ({ children, classNames, isOneDirection, maximumHeight }) => {
  const [checked, setChecked] = useState(true);
  const ref = useRef(null);
  const { t } = useTranslation();
  const toggleBoxClassNames = cn(
    'toggle-box',
    { 'toggle-box--unidirectional': isOneDirection },
    classNames
  );

  useEffect(() => {
    if (ref.current?.clientHeight > maximumHeight) {
      setChecked(false);
    }
  }, []);

  return (
    <div className={toggleBoxClassNames}>
      <input
        className="toggle-box__input"
        type="checkbox"
        readOnly
        checked={checked}
      />
      <div
        role="button"
        className="toggle-box__label"
        onClick={() => setChecked(true)}
        onKeyPress={() => {}}
        tabIndex={-1}
      >
        <span className="toggle-box__more" data-stat="residence-description">
          {t('detailed')}
        </span>
      </div>
      <div className="toggle-box__content" ref={ref}>
        {children}
      </div>
    </div>
  );
};

ToggleBox.displayName = `ToggleBox`;

ToggleBox.propTypes = {
  children: PropTypes.node,
  classNames: PropTypes.string,
  isOneDirection: PropTypes.bool,
  maximumHeight: PropTypes.number
};

export default ToggleBox;
